import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StringLocalized } from '../models/shared/string-localized';

@Pipe({
  name: 'localized',
  pure: false, // Allows automatic updates when language changes
  standalone: false,
})
export class LocalizedPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: StringLocalized | null | undefined): string {
    if (!value) {
      return '';
    }

    const currentLang = this.translate.currentLang || this.translate.getDefaultLang();
    return value[currentLang as keyof StringLocalized] || value['en'];
  }
}
